import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../constants/routes'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography';
import {doDeleteEvent} from '../../firebase/db'


import PropTypes from 'prop-types';

const styles = theme => ({
    paper: {
      padding: '1em',
      marginBottom: '1em',
    },
    button: {
        margin: theme.spacing.unit,
    },
    textField: {
      marginBottom: theme.spacing.unit *2,
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      
      
    },

    row: {
        border: '2px solid gray',
        padding: '8px',
        marginRight: '4px',
        display: 'inline-block'
    },
    eventDiv: {
        border: '3px solid gray',
        padding: '20px'
    },
    del: {
        color: 'white',
        textWeight: 'bold',
        padding: '4px',
        marginBottom: '8px',
        backgroundColor: 'red',
        cursor  : 'pointer'
    },
    inlineNav: {
        marginTop: '6px'
    },
   
  });

  const tempStyle = {
    content: {
     

    },

  rowHeadline: {
      fontWeight: 'bold',
      marginBottom: '0.3em',
  },
  rowContent: {
      marginBottom: '0.8em',
      padding: '0.2em',
      borderBottom: '2px solid #3f51b5',
      
  
  },
  rowContentAlert: {
      marginBottom: '0.5em',
      padding: '0.2em',
      borderBottom: '2px solid #f50057',
  },
  rowInfo: {
      color: 'gray',
      font: '1em',
  },
  navFooter: {
      borderTop: '1px solid gray',
      marginTop: '1em'
  }
}


class AdminCanidateEventDetails extends Component {

componentWillMount () {

    
    
}

toggleView = (routeTo) => {
    const { history } = this.props
    history.push(routes.ADMINCANIDATELIST)
}
deleteEvent = (eventId) =>{
    doDeleteEvent(eventId)
    const {history } = this.props
    history.push(routes.ADMINCANIDATELIST)
}


    render() {

        const { classes, openEvent } = this.props
        const {  date, id , timeRange, ort, task, pkw, info, created } = openEvent.event
        const timeStamp = created
        const dateFormatedLong = moment(date).format('dddd DD.MM.YYYY')
        return (
            <div className={styles.inlineBlock}>
                <Paper className={this.props.classes.paper}>
                    <Typography variant="headline" color='primary' gutterBottom>
                        Hilfebedarf
                    </Typography>
                    <div style={tempStyle.content}> 
                        <Typography variant="subheading" gutterBottom>
                            <div style={tempStyle.rowHeadline} >
                                Ausführung:
                            </div>
                            {timeRange==='onDate'
                                ? <div style={tempStyle.rowContentAlert} >Bestimmter Tag</div>
                                : <div style={tempStyle.rowContent} >Nach Vereinbarung</div>
                            }
                            {timeRange==='onDate'
                                ? <div style={tempStyle.rowHeadline} >Datum:</div>
                                : <div style={tempStyle.rowHeadline} >Bis zum: </div>
                            }
                            <div style={tempStyle.rowContent} >{dateFormatedLong}</div>
                            <div style={tempStyle.rowHeadline}>Hilfeleistung</div>
                            <div style={tempStyle.rowContent} >{task}</div>
                            <div style={tempStyle.rowHeadline}>Wohnort:</div>
                            <div style={tempStyle.rowContent} >{ort}</div>
                            <div style={tempStyle.rowHeadline}>PKW erforderlich:</div>
                            {pkw
                                ? <div style={tempStyle.rowContentAlert}>JA</div>
                                : <div style={tempStyle.rowContent}>NEIN</div>
                            }
                            <div style={tempStyle.rowHeadline}>Zusatzinformationen</div>
                            <div style={tempStyle.rowContent} >{info}</div>
                        </Typography>
                    
                        <Typography variant="body2" gutterBottom>
                        <div style={styles.row }>Erstellt am {moment(timeStamp).format('dddd DD.MM.YYYY')}</div>
                        <div style={styles.row }>Läuft ab {moment(date, "YYYY-MM-DD").fromNow()}</div>
                        </Typography>  
                    </div>
                    <div style={tempStyle.navFooter}>
                    <Button 
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={()=>this.toggleView('ADMINCANIDATELIST')}
                        size="small"
                    >
                        Zurück
                    </Button>
                    <Button 
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={()=>this.deleteEvent(id)}
                        size="small"
                        style={styles.button}
                    >
                        Löschen
                    </Button>
                    </div>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
    openEvent: state.adminCanidateState.currentOpenEvent

})

AdminCanidateEventDetails.propTypes = {
    openEvent: PropTypes.object.isRequired,
  };


export default compose(
    withRouter,
    connect(mapStateToProps),
    withStyles(styles)
    )   (AdminCanidateEventDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminCanidateEventDetails.js